<template>
  <div>
    <v-row v-if="isNbnOrder">
      <v-col cols="12" class="py-0">
        <span class="px-0 py-2 kayako" @click="setData('nbnOrder')">{{
          params.data.nbnOrderId
        }}</span>
      </v-col>
    </v-row>
    <v-row v-if="isAuditLog">
      <v-col cols="12" class="py-0">
        <v-icon
          medium
          v-bind="attrs"
          v-on="on"
          @click="setData('auditLog')"
          class="mx-0"
          color="primary"
          >mdi-eye</v-icon
        >
      </v-col>
    </v-row>
    <v-row v-if="isKayako">
      <v-col cols="12" class="py-0">
        <span class="px-0 py-2 kayako" @click="setData('kayako')">
          {{ params.data.customerReference }}
        </span>
      </v-col>
    </v-row>
    <v-row v-if="isStatus">
      <v-col cols="12" class="py-0">
        <span
          class="px-0 py-2"
          :class="params.data.status == 'Rejected' ? 'rejected' : ''"
          :title="displayedStatus"
          @click="setData('status')"
        >
          <!-- Order Cancelled is the same as Cancelled status in db level -->
          <!-- As requested by Johann, we changed the terms in frontend from Cancelled to Withdrawn, and Disconnected to Cancelled,
          This will be different from the db level.-->
          {{ displayedStatus }}
        </span>
      </v-col>
    </v-row>
    <v-row v-if="!isNbnOrder && !isKayako && !isStatus && !isAuditLog">
      <!--      <v-col cols="2" class="pl-3 pr-5 py-0">-->
      <!--        <v-tooltip bottom>-->
      <!--          <template v-slot:activator="{ on, attrs }">-->
      <!--            <v-icon-->
      <!--              medium-->
      <!--              v-bind="attrs"-->
      <!--              v-on="on"-->
      <!--              @click="setData('disconnectOrder')"-->
      <!--              class="mx-0"-->
      <!--              color="primary"-->
      <!--              :disabled="disableIcon(params.data, 'disconnect')"-->
      <!--            >mdi-close-network</v-icon-->
      <!--            >-->
      <!--          </template>-->
      <!--          <span>Disconnect Order</span>-->
      <!--        </v-tooltip>-->
      <!--      </v-col>-->
      <v-col cols="2" class="pl-3 pr-5 py-0">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              medium
              v-bind="attrs"
              v-on="on"
              @click="setData('order')"
              class="mx-0"
              color="primary"
              :disabled="
                params.data.orderType === '5G' &&
                  !(
                    params.data.customerReference != '' ||
                    params.data.customerAuthReference != ''
                  )
              "
              >mdi-format-list-bulleted-square</v-icon
            >
          </template>
          <span>View Order</span>
        </v-tooltip>
      </v-col>
      <v-col cols="4" class="pl-3 pr-0 py-0">
        <span class="px-0 py-2 kayako" @click="setData('order')"
          >Manage Service</span
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    orderItem: null,
    isNbnOrder: false,
    isKayako: false,
    isStatus: false,
    isAuditLog: false
  }),
  computed: {
    displayedStatus() {
      const s = this.params.data.status;
      if (s === "Cancelled") return "Order Withdrawn";
      if (s === "Disconnected") return "Cancelled";
      return s;
    }
  },
  methods: {
    setData(type) {
      let data = this.params.data;
      data.type = type;
      this.params.clicked(data);
    },
    disableIcon(item, button) {
      let disable = true;
      if (item.orderType === "NBN") {
        switch (button) {
          case "addressQuery":
            disable = !item.locationId;
            break;
          case "sq":
            disable = !item.locationId;
            break;
          case "appointment":
            disable = !item.appointmentId || item.appointmentId === "NA";
            break;
        }
      } else {
        if (button === "addressQuery" || button === "sq") disable = false;
      }

      return disable;
    }
  },
  mounted() {
    this.isNbnOrder = this.params.colDef.field == "nbnOrderId";
    this.isKayako = this.params.colDef.field == "kayakoConversation";
    this.isStatus = this.params.colDef.field == "status";
    this.isAuditLog = this.params.isAuditLog;
  }
});
</script>

<style scoped>
.kayako {
  text-decoration: underline;
  color: #2f5578 !important;
  cursor: pointer;
  font-weight: bold;
}

.rejected {
  text-decoration: underline;
  color: red !important;
  cursor: pointer;
}
</style>
